import { Box, Flex, HStack, Stack, Text } from "@chakra-ui/layout";
import React, { useRef } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
} from "@chakra-ui/react";

import dots from "../assets/iconz/more-horizontal.svg";
import AssignLearner from "./AssignLearner";
import AssignInstructor from "./AssignInstructor";

// used to display in grid view
export const PersonalProgramCard = ({ program }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [action, setAction] = React.useState("");
  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);
  const initRef = useRef();
  console.log(action);

  return (
    <>
      <Popover
        returnFocusOnClose={false}
        isOpen={isOpen}
        onClose={close}
        placement="right"
        closeOnBlur={true}
        initialFocusRef={initRef}
      >
        <PopoverTrigger>
          <Box
            sx={{
              borderRadius: "10px",
              boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
              cursor: "pointer",
            }}
            onClick={open}
          >
            <Box
              sx={{
                height: "225px",
                backgroundColor: "#c4c4c4",
                backgroundImage: `url('${program.imgSrc}')`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                borderRadius: "10px 10px 0 0",
              }}
            ></Box>

            {action === "learner" && (
              <AssignLearner
                id={program._id}
                action={action}
                close={() => setAction("")}
              />
            )}
            {action === "instructor" && (
              <AssignInstructor action={action} close={() => setAction("")} />
            )}

            <Box p={8}>
              <Flex justify="space-between">
                {/* program title */}
                <Text sx={{ fontWeight: "600", fontSize: "20px" }}>
                  {program.title}
                </Text>

                <Box sx={{ color: "#223D5D" }} mt="1">
                  <img src={dots} alt="" />
                </Box>
              </Flex>

              <Box mt="2">
                <Text sx={{ color: "#89969F" }}>{program.instructor}</Text>
              </Box>
            </Box>
          </Box>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverCloseButton />
          <PopoverBody>
            {/* summary */}

            <Box my="6">
              <Stack gap="4">
                <HStack gap="4" alignItems="top">
                  <Text onClick={() => setAction("learner")} cursor="pointer">
                    Assign to Learners
                  </Text>
                </HStack>

                <HStack gap="4" alignItems="top">
                  <Text
                    onClick={() => setAction("instructor")}
                    cursor="pointer"
                  >
                    Assign to Instructors
                  </Text>
                </HStack>

                <HStack gap="4" alignItems="top">
                  <Text cursor="pointer">Bookmark</Text>
                </HStack>
              </Stack>
            </Box>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </>
  );
};

// used to display in list view
export const PersonalProgramList = ({ program }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [action, setAction] = React.useState("");
  const open = () => setIsOpen(!isOpen);
  const close = () => setIsOpen(false);
  const initRef = useRef();
  return (
    <>
      <Box
        sx={{
          borderRadius: "10px",
          cursor: "pointer",
          border: "1px solid #F6F7FB",
        }}
        onClick={open}
      >
        <Box
          sx={{
            width: "100%",
          }}
        ></Box>

        {action === "learner" && (
          <AssignLearner
            id={program._id}
            action={action}
            close={() => setAction("")}
          />
        )}
        {action === "instructor" && (
          <AssignInstructor action={action} close={() => setAction("")} />
        )}

        <Box p={8}>
          <Flex justify="space-between">
            <Flex align="center">
              {/* program title */}
              <Text sx={{ fontWeight: "600", fontSize: "20px" }}>
                {program.title}
              </Text>
              <Text ml="12" sx={{ color: "#89969F" }}>
                {program.instructor}
              </Text>

              <Box>
                <Popover
                  returnFocusOnClose={false}
                  isOpen={isOpen}
                  onClose={close}
                  placement="right"
                  closeOnBlur={true}
                  initialFocusRef={initRef}
                >
                  <PopoverTrigger>
                    <Box
                      sx={{
                        borderRadius: "10px",
                        boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.25)",
                        cursor: "pointer",
                      }}
                      onClick={open}
                    >
                      {action === "learner" && (
                        <AssignLearner
                          id={program._id}
                          action={action}
                          close={() => setAction("")}
                        />
                      )}
                      {action === "instructor" && (
                        <AssignInstructor
                          action={action}
                          close={() => setAction("")}
                        />
                      )}
                    </Box>
                  </PopoverTrigger>
                  <PopoverContent>
                    <PopoverArrow />
                    <PopoverCloseButton />
                    <PopoverBody>
                      {/* summary */}

                      <Box my="6">
                        <Stack gap="4">
                          <HStack gap="4" alignItems="top">
                            <Text
                              onClick={() => setAction("learner")}
                              cursor="pointer"
                            >
                              Assign to Learners
                            </Text>
                          </HStack>

                          <HStack gap="4" alignItems="top">
                            <Text
                              onClick={() => setAction("instructor")}
                              cursor="pointer"
                            >
                              Assign to Instructors
                            </Text>
                          </HStack>

                          <HStack gap="4" alignItems="top">
                            <Text cursor="pointer">Bookmark</Text>
                          </HStack>
                        </Stack>
                      </Box>
                    </PopoverBody>
                  </PopoverContent>
                </Popover>
              </Box>
            </Flex>
            <Box sx={{ color: "#223D5D" }} mt="1">
              <img src={dots} alt="" />
            </Box>
          </Flex>
        </Box>
      </Box>
    </>
  );
};
